export default __webpack_public_path__ + "8f6a664c4e8a6383134738cfea6549cc.svg";